/**
 * @generated SignedSource<<2cfc8c6c7a2e9b9d7e62ce6e5c3047de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SetTxnsNeedsReviewInputObject = {
  needsReview: boolean;
  txnIds: ReadonlyArray<string>;
};
export type useTxnBulkActions_SetTxnsNeedsReviewMutation$variables = {
  input: SetTxnsNeedsReviewInputObject;
};
export type useTxnBulkActions_SetTxnsNeedsReviewMutation$data = {
  readonly setTxnsNeedsReview: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly updatedCount: number;
  } | null | undefined;
};
export type useTxnBulkActions_SetTxnsNeedsReviewMutation = {
  response: useTxnBulkActions_SetTxnsNeedsReviewMutation$data;
  variables: useTxnBulkActions_SetTxnsNeedsReviewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useTxnBulkActions_SetTxnsNeedsReviewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetTxnsNeedsReviewMutationPayload",
        "kind": "LinkedField",
        "name": "setTxnsNeedsReview",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTxnBulkActions_SetTxnsNeedsReviewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetTxnsNeedsReviewMutationPayload",
        "kind": "LinkedField",
        "name": "setTxnsNeedsReview",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "09aa02a33a3831d0dcfbbd50f3cc767a",
    "id": null,
    "metadata": {},
    "name": "useTxnBulkActions_SetTxnsNeedsReviewMutation",
    "operationKind": "mutation",
    "text": "mutation useTxnBulkActions_SetTxnsNeedsReviewMutation(\n  $input: SetTxnsNeedsReviewInputObject!\n) {\n  setTxnsNeedsReview(input: $input) {\n    updatedCount\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "935fc27d3bf58dcf8cdbfa0f7e70fc52";

export default node;
